var map = {
	"./angry-red.png": 1900,
	"./angry.png": 1901,
	"./anguished.png": 1902,
	"./anxious.png": 1903,
	"./beaming-face.png": 1904,
	"./confounded-normal.png": 1905,
	"./confounded.png": 1906,
	"./confused.png": 1907,
	"./crying-loudly.png": 1908,
	"./crying.png": 1909,
	"./devil.png": 1910,
	"./disappointed.png": 1911,
	"./distraught.png": 1912,
	"./dizzy.png": 1913,
	"./downcast.png": 1914,
	"./expressionless.png": 1915,
	"./fearful.png": 1916,
	"./frowning-eyebrows.png": 1917,
	"./frowning.png": 1918,
	"./grimacing.png": 1919,
	"./grinning-smiling-eyes.png": 1920,
	"./grinning-smiling-squinting-eyes.png": 1921,
	"./grinning.png": 1922,
	"./hand-1.png": 1923,
	"./hand-2.png": 1924,
	"./hand-3.png": 1925,
	"./hand-4.png": 1926,
	"./hand-5.png": 1927,
	"./inlove.png": 1928,
	"./innocent.png": 1929,
	"./kissing-closed-eyes.png": 1930,
	"./kissing.png": 1931,
	"./laughing.png": 1932,
	"./mask.png": 1933,
	"./neutral.png": 1934,
	"./persevering.png": 1935,
	"./relieved.png": 1936,
	"./sad.png": 1937,
	"./screaming.png": 1938,
	"./shy.png": 1939,
	"./sleepy.png": 1940,
	"./smile-licky.png": 1941,
	"./smile.png": 1942,
	"./smirk.png": 1943,
	"./smoked.png": 1944,
	"./steamy.png": 1945,
	"./stick-out-tongue.png": 1946,
	"./sunglasses.png": 1947,
	"./surprised.png": 1948,
	"./tongue-out.png": 1949,
	"./unamused.png": 1950,
	"./weary.png": 1951,
	"./wink-licky.png": 1952,
	"./wink.png": 1953,
	"./without-mouth.png": 1954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2159;